<template>
  <!-- on each event catogory add button that emits event id to parent -->
  <div class="event-category-card" :style="organizationCssVars" :class="eventCardClasses">
    <div class="event-heading" @click="toggleEvent">
      <div class="icon" :style="{ backgroundImage: `url(${eventCategory.icon})` }"></div>
      <div class="header">
        <h4 class="name">
          {{ $language.current | translateToCurrentLang(eventCategory.nameEs, eventCategory.nameEn) }}
        </h4>
      </div>

      <font-awesome-icon
        class="arrow"
        :icon="['fa', 'chevron-down']"
        :style="{ fontSize: '16px' }"
      />
    </div>

    <!-- Section that gets toggled -->
    <div class="event-details">
      <div class="white-bar"></div>
      <div class="event-details-content">
        <span
          v-html="
            $options.filters.translateToCurrentLang(
              $language.current,
              description[0],
              description[1],
            )
          "
        ></span>
        <div v-if="organizationDetails.eventDocumentationEnabled">
          <p :style="{ marginTop: '1rem' }">
            <b class="documentation-header" v-translate>You'll need documentation showing</b>
          </p>
          <span v-html="getCategoryDocumentationText(eventCategory)"></span>
          <p class="disclaimer" v-translate>
            If you have experienced more than one emergency, documentation is only required for one.
          </p>
        </div>
        <div class="button-container">
          <md-button
            :style="organizationCssVars"
            :class="{ button: !selected, 'selected-button': selected }"
            @click="onCategorySelected"
            >{{ buttonText }}</md-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'

export default {
  name: 'EventCategoryComponent',
  props: {
    eventCategory: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonText: this.$gettext('Select'),
      isCollapsed: true,
    }
  },
  mounted() {
    if (this.selected) {
      this.isCollapsed = false
      this.buttonText = this.$gettext('Selected')
    }
  },
  methods: {
    onCategorySelected() {
      if (!this.selected) {
        this.$emit('selected', this.eventCategory.id)
        this.buttonText = this.$gettext('Selected')
      } else {
        this.$emit('unselected', this.eventCategory.id)
        this.buttonText = this.$gettext('Select')
      }
    },
    toggleEvent() {
      this.isCollapsed = !this.isCollapsed
    },
    getCategoryDocumentationText(eventCategory) {
      return utils.translateToCurrentLang(
        this.$language.current,
        eventCategory.documentationDescShortHtmlEs,
        eventCategory.documentationDescShortHtml,
      )
    },
  },
  computed: {
    ...mapState(['organizationDetails', 'organizationCssVars']),
    eventCardClasses() {
      return {
        'toggle-close': this.isCollapsed,
      }
    },
    description() {
      const alternateDescriptionHtml = [
        this.eventCategory.alternateDescriptionHtmlEs,
        this.eventCategory.alternateDescriptionHtmlEn,
      ]
      const descriptionHtml = [
        this.eventCategory.descriptionHtmlEs,
        this.eventCategory.descriptionHtmlEn,
      ]
      return alternateDescriptionHtml || descriptionHtml
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/buttons';
.button {
  @include primary-button(var(--dark-brand-color));
  margin: 0 auto;
}
.selected-button {
  @include primary-button-selected(var(--dark-brand-color));
  margin: 0 auto;
}
.event-category-card {
  width: 100%;
  padding: 1rem;
  border-radius: 9px;
  margin: 1rem 0;
  box-sizing: border-box;
  background-color: var(--light-brand-color);
}
.icon {
  height: 2rem;
  width: 3rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.header {
  display: flex;
  align-items: left;
}
.name {
  margin: 1rem;
}
.white-bar {
  width: 100%;
  height: 1px;
  background: $white;
}
.documentation-header {
  font-weight: 600;
  margin: 2rem 0 0.3rem 0;
}
.disclaimer {
  font-size: 0.7rem;
  margin: 1.5rem 0;
}
.button-container {
  width: 100%;
  display: flex;
  margin-top: 1rem;
}
.arrow {
  width: 1rem;
  margin-left: auto;
}
.event-heading {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.event-details {
  // NIP 3/9/20 Guess this property is required! Just give it a huge value
  max-height: 100rem;
  overflow: hidden;
  transition: 0.5s ease all;
}
.toggle-close .event-details {
  max-height: 0;
}
.event-details-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
</style>
